import SystemFlashTopBarLogoLayout from "../../../layouts/SystemFlashTopBarLogoLayout";
import SystemExerciserLogoImage from "../../../images/SystemExerciserLogoImage";
import {ExerciserLogoTextSize} from "../../../../controllers/SystemExerciserLogoTextController";
import SystemDesktopTabletLeaveExerciserButton from "../../../buttons/SystemDesktopTabletLeaveExerciserButton";
import SystemFlashTopTexts from "../../../texts/SystemFlashTopTexts";
import {kExercisersTexts} from "../../../../constants/texts";
import SystemTabletTopBarLayout from "../../../layouts/SystemTabletTopBarLayout";

export default function ExerciserResultsTabletTopBar({onLeaveExerciserPressed}) {
    // Used in ExerciserResults to display top bar in
    // desktop mode

    // BUILD
    return (
        <SystemTabletTopBarLayout>
            <SystemFlashTopBarLogoLayout>
                <SystemExerciserLogoImage exerciserLogoSize={ExerciserLogoTextSize.XSMALL}/>
            </SystemFlashTopBarLogoLayout>
            <SystemFlashTopTexts title={kExercisersTexts.resultsTabletTopTitle}
                                 subtitle={kExercisersTexts.resultsTabletTopSubtitle}/>
            <SystemDesktopTabletLeaveExerciserButton onLeaveExerciserPressed={onLeaveExerciserPressed} />
        </SystemTabletTopBarLayout>
    );
}